import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary";
  children: React.ReactNode;
  className?: string;
}

export const CustomButton: React.FC<ButtonProps> = ({
  variant = "primary",
  children,
  className = "",
  disabled,
  ...props
}) => {
  const variantClasses = {
    primary:
      "bg-white text-black backdrop-blur-md hover:bg-gray-100 active:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50",
    secondary:
      "border border-[#494C56] bg-[#292930] text-white hover:bg-[#353840] hover:border-[#5a5d66] active:bg-[#242832] focus:outline-none focus:ring-2 focus:ring-[#494C56] focus:ring-opacity-50",
  };

  const combinedClasses = `flex px-8 py-[12px] justify-center items-center gap-1 self-stretch rounded-lg font-medium transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${variantClasses[variant]} ${className}`;

  return (
    <button className={combinedClasses} disabled={disabled} {...props}>
      {children}
    </button>
  );
};
